module.exports = __webpack_public_path__ + "static/img/zengjia.7f12603.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/zengjia.png
// module id = 2lFv
// module chunks = 24